import type { ComponentProps } from "react"
import { TRAVELTIME_ROUTE_ICON_PATH } from "@/v2-ui/icon/custom/traveltimeRoute/traveltimeRoute.constants"

export default function TraveltimeRoute(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path d={TRAVELTIME_ROUTE_ICON_PATH} fill={fill} />
    </svg>
  )
}
